import { infer as Infer, z } from 'zod';

import { questionFillGapsSchema } from './questionFillGaps.schema';
import { questionLongTextSchema } from './questionLongText.schema';
import { questionMatchingSchema } from './questionMatching.schema';
import { questionMultipleChoiceSchema } from './questionMultipleChoice.schema';
import { questionSingleChoiceSchema } from './questionSingleChoice.schema';
import { questionTranslateSchema } from './questionTranslate.schema';
import { questionVoiceRecordSchema } from './questionVoiceRecord.schema';

export const quizBuilderQuestionSchema = z.discriminatedUnion('type', [
  questionSingleChoiceSchema,
  questionMultipleChoiceSchema,
  questionFillGapsSchema,
  questionVoiceRecordSchema,
  questionMatchingSchema,
  questionLongTextSchema,
  questionTranslateSchema,
]);

export type QuizBuilderQuestionSchema = Infer<typeof quizBuilderQuestionSchema>;
